import * as DomBuilder from "./dom-builder.js";
import * as Utils from "./utils.js";
import * as CsvWriter from "../csv-writer.js";
import DialogDetails from "./DialogDetails.js";
import DialogStats from "./DialogStats.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class ComponentAnalysisTableGrouped {

    /** @type {Controller} */
    #controller;
    /** @type {Map<string,Transaction[]>} */
    #groupedTransactions;
    /** @type {Filter} */
    #selectedFilter;
    /** @type {Map<string,Filter>} */
    #allFilters;

    #tableBuilder = DomBuilder.bootstrapTableBuilder();

    /**
     *
     * @param controller {Controller}
     * @param groupedTransactions {Map<string,Transaction[]>}
     * @param allFilters {Map<string,Filter>}
     * @param selectedFilter {Filter}
     */
    constructor(controller, groupedTransactions, allFilters, selectedFilter) {
        this.#controller = controller;
        this.#groupedTransactions = groupedTransactions;
        this.#allFilters = allFilters;
        this.#selectedFilter = selectedFilter;
    }

    createNode() {
        this.#build(this.#groupedTransactions, this.#allFilters, this.#selectedFilter);
        return this.#tableBuilder.createNode();
    }

    /**
     *
     * @return {string[][]}
     */
    toCsv() {
        let rows = [['Group', 'Receipts', 'Expenses', 'Result', 'Cumulative']];
        let sum = 0;
        Array.from(this.#groupedTransactions.keys()).sort().forEach(key => {
            let transactions = this.#groupedTransactions.get(key);
            let expenses = transactions.filter(t => t.getValue() < 0).reduce((s, t) => s + t.getValue(), 0);
            let receipts = transactions.filter(t => t.getValue() > 0).reduce((s, t) => s + t.getValue(), 0);
            let result = receipts + expenses;
            sum += result;
            rows.push([
                key,
                CsvWriter.formatNumber(receipts),
                CsvWriter.formatNumber(expenses),
                CsvWriter.formatNumber(result),
                CsvWriter.formatNumber(sum)
            ]);
        });
        return rows;
    }

    #build(groupedTransactions, filters, filter) {
        let sum = 0;
        let cumulativeTransactions = [];
        Array.from(groupedTransactions.keys()).sort().forEach(key => {
            let transactions = groupedTransactions.get(key);
            let expenseTransactions = transactions.filter(t => t.getValue() < 0);
            let receiptTransactions = transactions.filter(t => t.getValue() > 0);
            let expenses = expenseTransactions.reduce((s, t) => s + t.getValue(), 0);
            let receipts = receiptTransactions.reduce((s, t) => s + t.getValue(), 0);
            let result = receipts + expenses;
            sum += result;
            cumulativeTransactions = cumulativeTransactions.concat(transactions);

            let row = DomBuilder.element('tr');
            row.append(DomBuilder.element('td', { class: 'group-key-cell' }, DomBuilder.span(key)));
            row.append(DomBuilder.element('td', { class: `value-cell positive` }, Utils.createFxValue(receipts, receiptTransactions)));
            row.append(DomBuilder.element('td', { class: `value-cell negative` }, Utils.createFxValue(expenses, expenseTransactions)));
            row.append(DomBuilder.element('td', { class: `value-cell result ${result < 0 ? 'negative' : 'positive'}` },
                    Utils.createFxValue(result, transactions)));
            row.append(DomBuilder.element('td', { class: `value-cell result ${sum < 0 ? 'negative' : 'positive'}` },
                    Utils.createFxValue(sum, cumulativeTransactions)));

            // details
            let path = filter.hasFilterFunc() ? filter.getName() + ' / ' : '';
            row.append(DomBuilder.element('td', { class: 'options-cell' }, [
                DomBuilder.link('', { class: 'fa fa-eye' }, () => {
                    let dialog = new DialogDetails(this.#controller, path + key, transactions, filter, filters);
                    dialog.show();
                }),
                DomBuilder.link('', { class: 'fa fa-th' }, () => {
                    let dialog = new DialogStats(this.#controller, path + key, transactions, filters);
                    dialog.show();
                })
            ]));

            this.#tableBuilder.addRowBefore(row);
        })
    }
}
